'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _WithDisplayName = require('../WithDisplayName');

var _WithDisplayName2 = _interopRequireDefault(_WithDisplayName);

require('./MenuItem.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MenuItem = function (_Component) {
  _inherits(MenuItem, _Component);

  function MenuItem(props) {
    _classCallCheck(this, MenuItem);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.onMouseEnter = function () {
      if (_this.props.onMouseEnter) {
        _this.props.onMouseEnter(_this.props.index, _this.props.value, _this.props.fieldValue);
      }
    };

    _this.onClick = function () {
      if (_this.props.onClick) {
        _this.props.onClick(_this.props.index, _this.props.value, _this.props.fieldValue);
      }
    };

    _this.state = {
      selected: false,
      hovered: false
    };
    return _this;
  }

  MenuItem.prototype.render = function render() {
    var _this2 = this;

    if (this.props.disable) {
      return _react2.default.createElement(
        'li',
        { className: 'disabled' },
        this.props.children
      );
    }

    return _react2.default.createElement(
      'li',
      {
        className: (0, _classnames2.default)({ selected: this.state.selected }, { hover: this.state.hovered }),
        onMouseDown: this.onClick,
        onMouseEnter: this.onMouseEnter,
        ref: function ref(item) {
          _this2.item = item;
        },
        tabIndex: 0,
        role: 'button' // eslint-disable-line
      },
      this.props.children
    );
  };

  return MenuItem;
}(_react.Component);

MenuItem.propTypes = process.env.NODE_ENV !== "production" ? {
  onClick: _propTypes2.default.func,
  onMouseEnter: _propTypes2.default.func,
  children: _propTypes2.default.element.isRequired,
  value: _propTypes2.default.any, // eslint-disable-line
  fieldValue: _propTypes2.default.string,
  disable: _propTypes2.default.bool,
  index: _propTypes2.default.number.isRequired
} : {};

MenuItem.defaultProps = {
  onClick: function onClick() {},
  onMouseEnter: function onMouseEnter() {},
  disable: false,
  value: undefined,
  fieldValue: undefined
};

exports.default = (0, _WithDisplayName2.default)(MenuItem, 'MenuItem');
module.exports = exports['default'];